import { defAction } from "../../../../helpers/defaultAction"
import api from './api'
import { reConstructionCategoryConstants } from "./constants"

export const reConstructionCategoryActions = {
	getKinds,
	getList,
	getVolumeList,
	getChilds,
	find,
	clear,
	createCategory,
	updateCategory,
	deleteCategory,
	restoreCategory,
	getPagedAll
}

function createCategory(values){
	const dispatchObj = {
		constants : reConstructionCategoryConstants.create,
		service   : {
			func   : api.create,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getPagedAll(values){
	const dispatchObj = {
		constants : reConstructionCategoryConstants.getPagedAll,
		service   : {
			func   : api.getPagedAll,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function updateCategory(values){
	const dispatchObj = {
		constants : reConstructionCategoryConstants.update,
		service   : {
			func   : api.update,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function deleteCategory(values){
	const dispatchObj = {
		constants : reConstructionCategoryConstants.delete,
		service   : {
			func   : api.delete,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function restoreCategory(values){
	const dispatchObj = {
		constants : reConstructionCategoryConstants.restore,
		service   : {
			func   : api.restore,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getKinds(values){
	const dispatchObj = {
		constants : reConstructionCategoryConstants.GetKinds,
		service   : {
			func   : api.getKinds,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getList(values){
	const dispatchObj = {
		constants : reConstructionCategoryConstants.GetList,
		service   : {
			func   : api.getList,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getVolumeList(values){
	const dispatchObj = {
		constants : reConstructionCategoryConstants.GetVolumeList,
		service   : {
			func   : api.getVolumeList,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getChilds(values){
	const dispatchObj = {
		constants : reConstructionCategoryConstants.GetChilds,
		service   : {
			func   : api.getChilds,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function find(values){
	const dispatchObj = {
		constants : reConstructionCategoryConstants.Find,
		service   : {
			func   : api.find,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function clear(){
	return (dispatch) => dispatch({
		type: reConstructionCategoryConstants.CLEAR
	})
}
